import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 60px;\n  height: auto;\n  padding: 16px;\n  border-radius: 6px;\n  background-color: ",
        ";\n  margin-top: 20px;\n\n  &.category {\n    min-height: 58px;\n  }\n\n  .current-area {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    height: 100%;\n\n    i {\n      margin-left: 4px;\n    }\n  }\n\n  @media (max-width: 1200px) {\n    &.search-page {\n      padding: 0 16px;\n      /* margin: 0 -16px; */\n      width: auto;\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 0 16px;\n    min-height: unset;\n    height: 50px;\n    margin: 0 -16px;\n    border-radius: 0;\n    .current-area {\n      flex-wrap: nowrap;\n      white-space: nowrap;\n      overflow-x: auto;\n      height: unset;\n      scrollbar-width: thin;\n      align-items: center;\n    }\n\n    &.slider-type {\n      padding: 12px 16px;\n      height: auto;\n      flex-direction: column;\n      align-items: unset;\n      margin: 0;\n      border-bottom: 1px solid ",
        ";\n\n      .reset-btn {\n        justify-content: flex-end;\n      }\n\n      .current-area {\n        flex-wrap: wrap;\n        margin-bottom: 0;\n        align-items: flex-end;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import SelectedFilterWrapper from "@/components/Categories/Menu/SelectedFilter";
import { useBooksQuery } from "@/hooks/useBooksQuery";
import styled from "styled-components";
import { findLabel } from "../../../api/booksProducts";
export const BookListSelectedFilter = (param)=>{
    let { slider  } = param;
    const { selectedFilterList , handleResetFilter , handleDetailFilter  } = useBooksQuery();
    if (selectedFilterList.length === 0) return;
    return /*#__PURE__*/ _jsx(SelectedFilterWrapper, {
        position: slider ? "sideSheet" : "top",
        button: /*#__PURE__*/ _jsx(SelectedFilterWrapper.ResetButton, {
            handleResetFilter: handleResetFilter
        }),
        children: selectedFilterList.map((filter)=>/*#__PURE__*/ _jsx(SelectedFilterWrapper.SelectedItem, {
                label: findLabel(filter.key, filter.value),
                onRemove: ()=>handleDetailFilter(filter.key, filter.value, filter.value)
            }, filter.value))
    });
};
export const Wrapper = styled.div.withConfig({
    componentId: "sc-b0c1ee62-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_100);
